// extracted by mini-css-extract-plugin
export default {"main":"App_main__nhgh3","mainDarkMode":"App_mainDarkMode__jPF2k","mainBackground":"App_mainBackground__0k8Pe","div":"App_div__Jjr5b"};